import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { CursoExterno } from '../../../../service/types/cursosExternos.types';
import { SimpleUser } from '../../cursos/builder/AsignacionManager';
import AsignacionCursoExternoManager from './AsignacionCursoExternoManager';
import CompletitudesExternoManager from './CompletitudesExternoManager';
import CursoExternoForm from './CursoExternoForm';

interface CursoExternoEditorProps {
  cursoExternoId?: string;
  initialValue?: CursoExterno;
  fetchUsers: () => Promise<SimpleUser[]>;
}

export default function CursoExternoEditor({ cursoExternoId, initialValue, fetchUsers }: CursoExternoEditorProps) {
  const [curso, setCurso] = useState<CursoExterno | undefined>(initialValue);
  const id = curso?.id ?? cursoExternoId;

  return (
    <div>
      <CursoExternoForm initialValue={curso} onSaved={setCurso} />
      {id && (
        <Tabs defaultActiveKey="asignaciones" className="mb-3">
          <Tab eventKey="asignaciones" title="Asignaciones">
            <AsignacionCursoExternoManager cursoExternoId={id} fetchUsers={fetchUsers} />
          </Tab>
          <Tab eventKey="completitudes" title="Completitudes">
            <CompletitudesExternoManager cursoExternoId={id} />
          </Tab>
        </Tabs>
      )}
      {!id && <p className="text-muted">Guarde el curso externo para poder administrar sus asignaciones.</p>}
    </div>
  );
}
